/**
 * The set of input field names for the activate user UI component.
 */
export var ActivateAccountFormInputField;
(function (ActivateAccountFormInputField) {
    ActivateAccountFormInputField["NAME"] = "name";
    ActivateAccountFormInputField["PASSWORD"] = "password";
    ActivateAccountFormInputField["CONFIRM_PASSWORD"] = "confirmPassword";
})(ActivateAccountFormInputField || (ActivateAccountFormInputField = {}));
